module.exports = __webpack_public_path__ + "static/media/index-popup-big-small.09e54240.png";